// ** Redux Imports
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"

// ** Axios Imports
import axios from "axios"

export const getBookmarks = createAsyncThunk(
  "layout/getBookmarks",
  async () => {
    const response = await axios.get("/api/bookmarks/data")
    return {
      data: response.data.suggestions,
      bookmarks: response.data.bookmarks
    }
  }
)

export const updateBookmarked = createAsyncThunk(
  "layout/updateBookmarked",
  async (id) => {
    await axios.post("/api/bookmarks/update", { id })
    return id
  }
)

const initialState = {
  query: "",
  bookmarks: [],
  suggestions: []
}
export const navbar = {
  state: initialState,
  reducers: {
    /**\
     * 
     */
    handleSearchQuery: (state, value) => {
      return {
        ...state,
        query: value
      }
    }
  },
  effects: (dispatch) => ({
    /**
     *
     * @param {*} value
     */
    onHandleSearchQuery(value) {
      this.handleSearchQuery(value)
    }
  })
}

// export const { handleSearchQuery } = layoutSlice.actions;

// export default layoutSlice.reducer;
